module.exports = __webpack_public_path__ + "static/media/color.4da83692.gif";